import { Injectable } from '@angular/core';
import { gql, Subscription } from 'apollo-angular';

const APPLICATION_POST_SUBSCRIPTION = gql`
  subscription postEvents($applicationId: String) {
    onApplicationPostEvent(input: { applicationId: $applicationId }) {
      data {
        applicationId
        messageId
        description
        initiatingUserId
        messageType
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ApplicationPostSubscriptionService extends Subscription {
  document = APPLICATION_POST_SUBSCRIPTION;
}
